/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    roleList: {
        "application": "Application",
        "roleList": "Role list",
        "roleName": "Role name",
        "roleNumber": "Role number",
        "applicationExamples": "Application examples",
        "founder": "Founder",
        "creationTime": "Creation time",
        "remarks": "Remarks",
        "numberOfUsersAssociatedWithRoles": "Number of users associated with roles",
        "state": "State",
        "edit": "Edit",
        "disable": "Disable",
        "delete": "Delete",
        "resourceInformation": "Resource information",
        "pageElements": "Page elements",
        "pageElementName": "Page element name",
        "pageElementNumber": "Page element number",
        "updateTime": "Update time",
        "addRole": "Add role",
        "editRole": "Edit role",
        "roleInformation": "Role information",
        "classify": "Classify",

        "message1": "Allocation resource cannot be empty",
        "message2": "Save succeeded",
        "placeholder1": "Role name cannot be empty",
        "placeholder2": "Role name is limited to 20 characters",
        "placeholder3": "It cannot be modified after creation",
        "placeholder4": "Please enter alphanumeric characters or a combination of both, limited to 20 characters",

        "text1": "Resource information",
    }
};


// WEBPACK FOOTER //
// ./src/config/langs/en_US/roleList.js